import React from 'react';

function DeleteAccount() {
  return (
    <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.84642 5.6489C1.84642 8.76992 4.32524 11.2978 7.38568 11.2978C10.4461 11.2978 12.9249 8.76992 12.9249 5.6489C12.9249 2.52788 10.4461 0 7.38568 0C4.32524 0 1.84642 2.52788 1.84642 5.6489ZM9.23211 14.4442V12.4765C8.14056 12.1891 6.99898 12.1594 5.89485 12.3914C4.7907 12.6235 3.75331 13.1103 2.86215 13.8145C1.97099 14.5186 1.24973 15.4214 0.753611 16.4537C0.257503 17.4861 -0.00028242 18.6205 2.32188e-07 19.7703L1.84642 19.7712C1.84625 18.8673 2.05875 17.9767 2.46604 17.174C2.87335 16.3713 3.46358 15.68 4.18715 15.1581C4.91074 14.6362 5.74656 14.299 6.62441 14.1747C7.50227 14.0506 8.39653 14.143 9.23211 14.4442ZM7.38568 9.41484C9.42598 9.41484 11.0785 7.72958 11.0785 5.6489C11.0785 3.56822 9.42598 1.88297 7.38568 1.88297C5.34539 1.88297 3.69284 3.56822 3.69284 5.6489C3.69284 7.72958 5.34539 9.41484 7.38568 9.41484ZM11.7773 13.3427L13.466 15.0637H10.1553V16.9467H13.466L11.7773 18.6677L13.0837 20L17 16.0052L13.0837 12.0104L11.7773 13.3427Z"
        fill="black"
      />
    </svg>
  );
}

export default DeleteAccount;
